<template>
  <div class="upload">
    <div class="title">
      <h3 @click="quit">
        <i class="el-icon-arrow-left"></i>
        {{ id ? $t("publicity.editDate") : $t("publicity.uploadData") }}
        <span>
          {{ $t("common.required1") }}<i>*</i>{{ $t("common.required2") }}</span
        >
      </h3>
    </div>
    <div class="formdata">
      <el-form
        ref="form"
        :model="sizeForm"
        label-width="200px"
        size="mini"
        :rules="rules"
      >
        <el-form-item :label="$t('publicity.language') + ':'" prop="language">
          <el-radio v-model="sizeForm.language" label="zh_CN">
            {{ $t("publicity.chinese") }}</el-radio
          >
          <el-radio v-model="sizeForm.language" label="en_US">
            {{ $t("publicity.English") }}</el-radio
          >
        </el-form-item>
        <el-form-item
          :label="$t('publicity.dataUsername') + ':'"
          prop="informationName"
        >
          <el-input
            v-model="sizeForm.informationName"
            :placeholder="$t('publicity.placeholder')"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('publicity.information') + ':'" prop="url">
          <el-upload
            drag
            ref="upload"
            class="upload-demo"
            :action="baseFileUrl"
            :headers="getToken()"
            name="file"
            :on-success="handSuccess"
            :file-list="fileList"
          >
            <el-button size="small" class="select" type="primary">
              {{ $t("publicity.clickUpload") }}</el-button
            >
          </el-upload>
          <p class="tishi"> {{ $t("publicity.tishi2") }}</p>
        </el-form-item>
        <el-button
          type="primary"
          class="button"
          @click="submit(sizeForm.size, sizeForm.url)"
          >{{ $t("common.submit") }}</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  addTravel,
  getTravelBrochure,
} from "../../../../api/travelBrochure.js";
import { baseFileUrl } from "../../../../utils/common.js";

export default {
  data() {
    return {
      baseFileUrl: baseFileUrl(),
      sizeForm: {
        id: "",
        language: "", // 中英文
        informationName: "", // 资料名称
        size: "",
        url: "",
      },
      fileList: [],
      id: this.$route.query.id,
    };
  },

  created() {
    this.getItem();
  },
  computed: {
    rules() {
      var validatorUrl = (rule, value, callback) => {
        if (!this.sizeForm.url) {
          callback(new Error(this.$t("dialog.message12")));
        } else {
          callback();
        }
      };
      return {
        language: [
          {
            required: true,
            message: this.$t("dialog.message13"),
            trigger: "blur",
          },
        ],
        informationName: [
          {
            required: true,
            message: this.$t("dialog.message14"),
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("dialog.message15"),
            validator: validatorUrl,
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    async getItem() {
      if (this.id) {
        const params = {
          id: this.id,
        };
        try {
          const { data } = await getTravelBrochure(params);
          if (data.code === 200) {
            this.sizeForm = data.data;
            this.fileList.push({
              url: this.sizeForm.url,
              name: this.sizeForm.informationName,
            });
          }
        } catch (err) {
          this.$message.error(err);
        }
      }
    },
    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },
    handSuccess(file) {
      if (file.code == 200) {
        const { size, url } = file.data;
        this.sizeForm.size = size;
        this.sizeForm.url = url;
      }
    },
    async submitForm(id) {
      if (id) {
        this.sizeForm.id = this.id;
      }
      try {
        const { data } = await addTravel(this.sizeForm);
        if (data.code === 200) {
          this.$router.push("/backIndex/dataIndex");
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    async submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submitForm(this.id);
        } else {
        }
      });
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    quit() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.upload {
  box-sizing: border-box;
  padding: 18px 26px 0 0;
  background: white;
  height: 820px;
  .title {
    height: 55px;
    padding-left: 26px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 35px;
    h3 {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
      span {
        margin-left: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        i {
          font-style: normal;
          color: red;
        }
      }
    }
    button {
      width: 88px;
      height: 32px;
      border: 1px solid #006fb8;
      color: #006fb8;
      background: white;
      margin-left: 10px;
    }
  }
  .formdata {
    width: 560px;
    margin: 0 auto;
    .select {
      display: block;
      font-style: normal;

      min-width: 95px;
      height: 28px;
      background: #ffffff;
      color: #666;
      border-radius: 4px;
      border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .button {
      width: 77px;
      height: 28px;
      line-height: 5px;
      margin-left: 200px;
      background: #006fb8;
    }
    .tishi {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      line-height: 19px;
    }
  }
}
</style>
<style scoped>
.upload-demo >>> .el-upload-dragger {
  width: 360px;
  height: 32px;
  border: none;
}
</style>
